<template>
  <div>

    <div class="d-flex mt-2">
      <feather-icon icon="TruckIcon" size="19" />
      <h4 class="mb-0 ml-50">
        {{ $t('Device Information') }}
      </h4>
    </div>

    <b-row class="mt-2">

      <b-col cols="12" md="6">
        <b-form-group :label="$t('Device Name')" label-for="vi-name-id">
          <b-input-group class="input-group-merge">
            <b-form-input v-model="deviceData.name" id="vi-name-id" :state="errors && ('name' in errors) ? false : null"
              :placeholder="$t('Device Name')" />
          </b-input-group>
          <small v-if="errors && ('name' in errors)" class="text-danger">
            {{ $t(errors['name'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <!-- unique id -->
      <b-col cols="12" md="6">
        <b-form-group :label="$t('IMEI Number')" label-for="vi-unique-id">
          <b-input-group class="input-group-merge">
            <b-form-input :readonly="!$store.state.auth.userData.roles.includes('Super Admin')"
                          v-model="deviceData.uniqueid"
                          :state="errors && ('uniqueid' in errors) ? false : null"
              id="vi-unique-id" :placeholder="$t('Unique Id')" />
          </b-input-group>
          <small v-if="errors && ('uniqueid' in errors)" class="text-danger">
            {{ $t(errors['uniqueid'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group :label="$t('Hashed IMEI')" label-for="hashed-imei-id">
          <b-input-group class="input-group-merge">
            <b-form-input :readonly="!$store.state.auth.userData.roles.includes('Super Admin')"
                          v-model="deviceData.hashed_imei"
                          :state="errors && ('hashed_imei' in errors) ? false : null"
              id="vi-unique-id" :placeholder="$t('Hashed IMEI')" />
          </b-input-group>
          <small v-if="errors && ('hashed_imei' in errors)" class="text-danger">
            {{ $t(errors['hashed_imei'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <!-- owner  -->
      <b-col cols="12" md="6">
        <b-form-group :label="$t('Device Owner')" label-for="vi-owner-id">
          <v-select v-model="deviceData.owner_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name" :options="lists.owners" :reduce="owner => owner.id"
            v-on:input="refilterContract(deviceData.owner_id)" />
          <small v-if="errors && ('owner_id' in errors)" class="text-danger">
            {{ $t(errors['owner_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>



      <!-- category  -->

      <b-col cols="12" md="6">
        <b-form-group :label="$t('Device Category')" label-for="vi-category-id">
          <v-select :state="null" v-model="deviceData.category"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :options="categoriesOptions"
            @input="getTypesByCategory($event), filterSubstitutesDevices($event)" />
          <small v-if="errors && ('category' in errors)" class="text-danger">
            {{ $t(errors['category'][0]) }}
          </small>
        </b-form-group>
      </b-col>


      <!-- type  -->
      <b-col cols="12" md="6">
        <b-form-group :label="$t('Device Type')">
          <v-select v-model="deviceData.type_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="t => t.name" :options="lists.types" :reduce="type => type.id" />
          <span class="invalid-feedback"> error </span>
          <small v-if="errors && ('type_id' in errors)" class="text-danger">
            {{ $t(errors['type_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>


      <!-- group  -->
      <b-col cols="12" md="6">
        <b-form-group :label="$t('Device Group')" label-for="vi-group-id">
          <v-select v-model="deviceData.group_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="g => g.name" :options="lists.groups" :reduce="group => group.id" />
          <small v-if="errors && ('group_id' in errors)" class="text-danger">
            {{ $t(errors['group_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>


      <!-- contract  -->
      <b-col cols="12" md="6">
        <b-form-group :label="$t('Device Contract')" label-for="vi-contract-id">
          <v-select style="margin-buttom:55px" v-model="deviceData.contract_id"
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" :getOptionLabel="t => t.name"
            :options="lists.contracts" :reduce="contract => contract.id" />
          <small v-if="errors && ('contract_id' in errors)" class="text-danger">
            {{ $t(errors['contract_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <!-- door number -->
      <b-col cols="12" md="3">
        <b-form-group :label="$t('Door Number')">
          <b-input-group class="input-group-merge">
            <b-form-input v-model="deviceData.door_number" :state="errors && ('door_number' in errors) ? false : null"
              :placeholder="$t('Door Number')" />
          </b-input-group>
          <small v-if="errors && ('door_number' in errors)" class="text-danger">
            {{ $t(errors['door_number'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <!-- weight -->
      <b-col cols="12" md="3">
        <b-form-group :label="$t('Weight')">
          <b-input-group class="input-group-merge">
            <b-form-input v-model="deviceData.weight" :state="errors && ('weight' in errors) ? false : null"
              :placeholder="$t('Weight')" />
          </b-input-group>
          <small v-if="errors && ('weight' in errors)" class="text-danger">
            {{ $t(errors['weight'][0]) }}
          </small>
        </b-form-group>
      </b-col>

      <!-- plate number -->
      <b-col md="6" xl="6" class="mb-1">

        <!-- number -->
        <b-form-group :label="$t('Plate Number')" label-for="plate-number">

          <b-form-input v-model="deviceData.plate_number" id="plate-number" :placeholder="$t('Plate Number')" />

          <small v-if="errors && ('plate_number' in errors)" class="text-danger">
            {{ $t(errors['plate_number'][0]) }}
          </small>

        </b-form-group>
      </b-col>
      <b-col md="6" xl="1" class="mb-1">
        <!-- right char -->
        <b-form-group :label="$t('Plate Right Liter')" label-for="plate-right-char">
          <b-form-input :state="errors && ('plate_right' in errors) ? false : null" v-model="deviceData.plate_right"
            id="plate-right-char" :placeholder="$t('Plate Right Liter')" />
          <small v-if="errors && ('plate_right' in errors)" class="text-danger">
            {{ $t(errors['plate_right'][0]) }}
          </small>

          <!-- <v-select v-model="deviceData.plate_right" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name" :options="arabicLetters" :reduce="letter => letter.id" /> -->
        </b-form-group>
      </b-col>
      <b-col md="6" xl="1" class="mb-1">
        <!-- middle char -->
        <b-form-group :label="$t('Plate Middle Liter')" label-for="plate-middle-char">
          <b-form-input :state="errors && ('plate_middle' in errors) ? false : null" v-model="deviceData.plate_middle"
            id="plate-middle-char" :placeholder="$t('Plate Middle Liter')" />
          <small v-if="errors && ('plate_middle' in errors)" class="text-danger">
            {{ $t(errors['plate_middle'][0]) }}
          </small>

          <!-- <v-select v-model="deviceData.plate_middle" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name" :options="arabicLetters" :reduce="letter => letter.id" />
          <small v-if="errors && ('plate_middle' in errors)" class="text-danger">
            {{ $t(errors['plate_middle'][0]) }}
          </small> -->

        </b-form-group>
      </b-col>
      <b-col md="6" xl="1" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('Plate Left Liter')" label-for="plate-left-char">
          <b-form-input :state="errors && ('plate_left' in errors) ? false : null" v-model="deviceData.plate_left"
            id="plate-left-char" :placeholder="$t('Plate Left Liter')" />
          <!-- <v-select v-model="deviceData.plate_left" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name" :options="arabicLetters" :reduce="letter => letter.id" /> -->
          <small v-if="errors && ('plate_left' in errors)" class="text-danger">
            {{ $t(errors['plate_left'][0]) }}
          </small>

        </b-form-group>
      </b-col>

      <b-col cols="12" md="6" xl="1">

      </b-col>
      <!-- drivers  -->
      <b-col cols="12" md="6" xl="4">
        <b-form-group :label="$t('Device Driver')" label-for="vi-owner-id">
          <v-select v-model="deviceData.driver_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
            :getOptionLabel="o => o.name" :options="lists.drivers" :reduce="driver => driver.id" />
          <small v-if="errors && ('driver_id' in errors)" class="text-danger">
            {{ $t(errors['driver_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>


      <b-col cols="6" md="6" xl="4">
        <b-form-group :label="$t('Substitutes Devices')" label-for="vi-substitute-id">
          <v-select :placeholder="'Select work area'" v-model="deviceData.substitute_id" :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                    :getOptionLabel="o => o.name" :options="substitutesOptions" :reduce="substitutes => substitutes.id" />
          <small v-if="errors && ('substitute_id' in errors)" class="text-danger">
            {{ $t(errors['substitute_id'][0]) }}
          </small>
        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('Support vehicle')" label-for="plate-left-char">
          <b-form-checkbox v-model="deviceData.is_support" :value="true" />

          <small v-if="errors && ('is_support' in errors)" class="text-danger">
            {{ $t(errors['is_support'][0]) }}
          </small>

        </b-form-group>
      </b-col>

      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('Has Cam')" label-for="has_cam">
          <b-form-checkbox v-model="deviceData.has_cam" :value="true" />

          <small v-if="errors && ('has_cam' in errors)" class="text-danger">
            {{ $t(errors['has_cam'][0]) }}
          </small>

        </b-form-group>
      </b-col>



      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with WASL')" label-for="wasl">
          <b-form-checkbox v-model="deviceData.wasl" :value="true" />

          <small v-if="errors && ('wasl' in errors)" class="text-danger">
            {{ $t(errors['wasl'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with CAP')" label-for="cap">
          <b-form-checkbox v-model="deviceData.cap" :value="true" />

          <small v-if="errors && ('cap' in errors)" class="text-danger">
            {{ $t(errors['cap'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with MADINATI')" label-for="madinati">
          <b-form-checkbox v-model="deviceData.madinati" :value="true" />

          <small v-if="errors && ('madinati' in errors)" class="text-danger">
            {{ $t(errors['madinati'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('connected with amana riyadh')" label-for="amana_riyadh">
          <b-form-checkbox v-model="deviceData.amana_riyadh" :value="true" />

          <small v-if="errors && ('amana_riyadh' in errors)" class="text-danger">
            {{ $t(errors['amana_riyadh'][0]) }}
          </small>

        </b-form-group>
      </b-col>


      <b-col md="6" xl="2" class="mb-1">
        <!-- left char -->
        <b-form-group :label="$t('is substitute')" label-for="plate-left-char">
          <b-form-checkbox v-model="deviceData.is_substitute" :value="true" />

          <small v-if="errors && ('is_substitute' in errors)" class="text-danger">
            {{ $t(errors['is_substitute'][0]) }}
          </small>

        </b-form-group>
      </b-col>

    </b-row>

  </div>
</template>

<script>

import {
  BButton, BCol,
  BFormGroup,
  BFormInput,
  BInputGroup, BInputGroupPrepend, BRow, BAlert, BFormCheckbox
} from 'bootstrap-vue'

import vSelect from 'vue-select'
import { OrbitSpinner } from 'epic-spinners'
import { computed, ref, onMounted } from '@vue/composition-api'
import store from '@/store'
import { getSubstitute, getCategoriesBy } from '@/app/share/lists'
export default {

  components: {
    BRow,
    BCol,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BButton,
    BFormCheckbox,
    vSelect,
    OrbitSpinner
  },

  setup() {
    const auth = store.state.auth.userData
    const s = store.state.device

    const deviceData = computed(() => s.data)

    const errors = computed(() => s.errors)



    /////options-start//////


    const substitutesOptions = ref([])
    const substitutesOptions_orig = ref([])
    const categoriesOptions = ref([])
    onMounted(() => {
      fetchLists(auth.id)
    })

    const fetchLists = (authId) => {

      getCategoriesBy({ type: 'device' }).then((response) => categoriesOptions.value = response.data.data).catch(reason => console.log(reason))
      getSubstitute({ user: authId, isSubstitute: true, cols: 'id,name,category' }).then((response) => {
        substitutesOptions.value = response.data.data
        substitutesOptions_orig.value = response.data.data
      }).catch(reason => console.log(reason))

    }
    const filterSubstitutesDevices = (selectedCategory) => {

      if (selectedCategory != null) {
        substitutesOptions.value = substitutesOptions_orig.value.filter(device => device.category == selectedCategory)
      } else {
        substitutesOptions.value = substitutesOptions_orig.value
      }


    }
    /////options-end ///////
    const getTypesByCategory = cat => {
      if (cat != undefined || cat != null) {
        store.dispatch(
          'device/fetchTypesByCategory',
          cat
        )
      }

    }


    const lists = computed(() => {

      return {
        owners: s.ownersOptions,
        groups: s.groupsOptions,
        contracts: s.contractsOptions,
        drivers: s.driversOptions,
        types: s.typesOptions,
      }
    })
    const refilterContract = (owner_id) => {

      let params = { 'user': auth.id, 'contractors[]': owner_id }

      store.dispatch('device/refilterContractsByOwner', params)

    }



    return {
      getTypesByCategory,
      refilterContract,
      deviceData,
      lists,
      errors,

      substitutesOptions,
      categoriesOptions,
      filterSubstitutesDevices

    }
  }

}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

.repeater-form {
  overflow: visible;
  transition:
    .35s height;
}

.v-select .vs__selected-options {
  flex-wrap: nowrap;
}
</style>
